import { useState, useRef, useEffect } from 'react';




export const ColumnToggle = ({ allColumns, getToggleHideAllColumnsProps }) => {

  const columnToggleRef = useRef(); 

  const [columnToggleOpen, setColumnToggleOpen] = useState(false);

  useEffect(() => {
      const handleOutside = (e) => {
        if (columnToggleRef.current && !columnToggleRef.current.contains(e.target)) {
          setColumnToggleOpen(false);
        }
      };
      document.addEventListener("mousedown", handleOutside);
      return () => document.removeEventListener("mousedown", handleOutside);
    }, []);


  
  return (
    <div className="position-relative d-inline-block" ref={columnToggleRef}>
            <button
              className="btn btn-outline-primary btn-sm rounded-3 fw-medium"
              onClick={() => setColumnToggleOpen(prev => !prev)}>
              Columns ▾
            </button>
            {columnToggleOpen && (
              <div
                className="border rounded-3 bg-white shadow-sm p-3 mt-1"
                style={{
                  position: "absolute", right: 0, zIndex: 1000,
                  minWidth: "200px", maxHeight: "300px", overflowY: "auto"
                }}>
                <div className="mb-2 pb-2 border-bottom">
                  <label className="d-flex align-items-center gap-2"
                    style={{ cursor: "pointer", fontSize: "0.9rem" }}>
                    <input type="checkbox" {...getToggleHideAllColumnsProps()} />
                    <span className="fw-medium">Toggle All</span>
                  </label>
                </div>
                {allColumns.map(column => (
                  <label key={column.id}
                    className="d-flex align-items-center gap-2 py-1"
                    style={{ cursor: "pointer", fontSize: "0.88rem" }}>
                    <input type="checkbox" {...column.getToggleHiddenProps()} />
                    <span>{column.Header || column.id}</span>
                  </label>
                ))}
              </div>
            )}
  </div>
  );
};